import type { IconData } from '@stacksjs/iconify-core'

export const caoDaiSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M29.056 5.565a6.057 6.057 0 0 0-10.112 0c-4.174 6.163-11.034 17.008-16.85 29.6c-1.74 3.77.599 8.1 4.797 8.532c3.937.405 9.696.803 17.11.803c7.412 0 13.171-.398 17.108-.803c4.199-.432 6.538-4.762 4.797-8.531c-5.815-12.593-12.675-23.438-16.85-29.6m7.127 22.83a2.6 2.6 0 0 0 0-2.79C33.22 20.945 28.862 18 24 18s-9.221 2.945-12.183 7.605a2.6 2.6 0 0 0 0 2.79C14.78 33.055 19.14 36 24 36s9.221-2.945 12.183-7.605M24 22a5 5 0 1 1 0 10a5 5 0 0 1 0-10\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default caoDaiSolid
